import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { toast } from "sonner";
import { CheckCircle2, XCircle, ChevronDown, ChevronUp } from "lucide-react";

export default function AdminFalciApplications() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("pending");
  const [open, setOpen] = useState(null);
  const [notes, setNotes] = useState("");

  const load = () => {
    const params = tab && tab !== "all" ? `?status=${tab}` : "";
    api.get(`/admin/falci-applications${params}`, adminApi()).then(({ data }) => setItems(data));
  };
  useEffect(() => { load(); }, [tab]);  // eslint-disable-line

  const approve = async (id) => {
    if (!window.confirm("Bu başvuruyu onaylamak ve kullanıcıyı falcı yapmak istiyor musun?")) return;
    try { await api.post(`/admin/falci-applications/${id}/approve`, {}, adminApi()); toast.success("Onaylandı"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };
  const reject = async (id) => {
    try { await api.post(`/admin/falci-applications/${id}/reject`, { notes }, adminApi()); toast.success("Reddedildi"); setOpen(null); setNotes(""); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  return (
    <div className="font-admin-body" data-testid="admin-falci-apps">
      <h1 className="font-admin-head text-3xl mb-4">Falcı Başvuruları</h1>
      <div className="flex gap-2 mb-4">
        {[["pending","Bekleyen"],["approved","Onaylı"],["rejected","Red"],["all","Tümü"]].map(([k,l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`fa-tab-${k}`} className={`px-3 py-1.5 rounded-full text-sm ${tab === k ? "bg-[#F59E0B]/20 text-[#F59E0B]" : "bg-white/5 text-white/60"}`}>{l}</button>
        ))}
      </div>

      <div className="space-y-2">
        {items.map((a) => (
          <div key={a.id} className="admin-card p-4" data-testid={`app-${a.id}`}>
            <div className="flex items-center justify-between">
              <div>
                <div className="font-admin-head text-lg">{a.display_name} <span className="text-xs text-white/40">({a.email})</span></div>
                <div className="text-xs text-white/60">{(a.specialties || []).join(", ")} • {a.experience_years} yıl deneyim • {a.price_per_reading} jeton/yorum</div>
                <div className="text-[10px] text-white/40 mt-1">Tarih: {new Date(a.created_at).toLocaleString("tr-TR")}</div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-xs px-2 py-1 rounded-full ${a.status === "approved" ? "bg-emerald-500/20 text-emerald-300" : a.status === "rejected" ? "bg-red-500/20 text-red-300" : "bg-amber-500/20 text-amber-300"}`}>{a.status}</span>
                <button onClick={() => setOpen(open === a.id ? null : a.id)} className="admin-btn-ghost text-xs px-2 py-1">{open === a.id ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}</button>
              </div>
            </div>
            {open === a.id && (
              <div className="mt-3 pt-3 border-t border-[#27272A] text-sm space-y-2">
                <div><span className="text-white/50">Tam Ad:</span> {a.full_name}</div>
                {a.phone && <div><span className="text-white/50">Telefon:</span> {a.phone}</div>}
                <div><span className="text-white/50">Bio:</span> {a.bio}</div>
                {a.sample_reading && <div><span className="text-white/50">Örnek Yorum:</span><div className="mt-1 p-3 bg-white/5 rounded-lg text-xs whitespace-pre-wrap">{a.sample_reading}</div></div>}
                {a.status === "pending" && (
                  <div className="flex gap-2 mt-3">
                    <button onClick={() => approve(a.id)} data-testid={`approve-${a.id}`} className="admin-btn flex items-center gap-1"><CheckCircle2 className="w-4 h-4" /> Onayla</button>
                    <input value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Red nedeni..." className="admin-input flex-1" />
                    <button onClick={() => reject(a.id)} data-testid={`reject-${a.id}`} className="admin-btn-ghost text-red-400 flex items-center gap-1"><XCircle className="w-4 h-4" /> Reddet</button>
                  </div>
                )}
                {a.admin_notes && <div className="text-xs text-white/50 mt-2">Admin notu: {a.admin_notes}</div>}
              </div>
            )}
          </div>
        ))}
        {items.length === 0 && <div className="text-center text-white/40 py-16">Bu sekmede başvuru yok.</div>}
      </div>
    </div>
  );
}
